import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ConnectionAuthInfo } from '../types/IConnectionAuthInfo';
import { UnencryptedConnectionKeychain } from '../types/IConnectionKeyChain';

export interface RevertFlowParams {
  id: string;
  version: number;
  keychains?: UnencryptedConnectionKeychain[];
  encryptedPasswordKeyId?: string;
}

export interface RevertFlowResult extends IResult {
  failedConnection?: ConnectionAuthInfo;
}

export class RevertFlowRequest extends Request<RevertFlowParams, RevertFlowResult> {
  constructor(params: RevertFlowParams) {
    super('revertFlow', params);
  }
}
